import { findCountryByAlpha3Code } from '@src/common/auth';
import type { Alpha3Code } from '@src/domains/customers/types/auth';

export function resolveDialCode(nationality: Alpha3Code): string | null {
  return findCountryByAlpha3Code(nationality)?.dialCode ?? null;
}
